import { createModal } from '@/components/create-modal';
import { h, render } from 'preact';
import { CoinConfirmContent, CoinPaymentContent } from './components';
import { CoinUnloginContent } from './components/unlogin-modal';

export interface IJoliCoin {
  balance: number;
  enableAutoDeduct: boolean;
}

export interface IGem {
  balance: number;
  enableAutoDeduct: boolean;
}

export interface IPaymentChoice {
  productId: string;
  totalAmountStr: string;
  quantity: number;
  defaultSelected?: boolean;
}

interface IButton {
  text: string;
  onPress: (...args: any[]) => void;
}

export const createConfirmJolicoinModal = (params: {
  data: {
    userCurrency: IJoliCoin | IGem;
    enableAutoDeduct: boolean;
    quantity: number;
    currency: 'JOLI_COIN' | 'JOLI_GEM';
  };
  buttons: {
    confirm: IButton;
    cancel: IButton;
    onEnableDeductChanged: (enalbed: boolean) => void;
  };
}) => {
  const modal = createModal({
    title: '',
    content: (
      <CoinConfirmContent
        currency={params.data.currency}
        balanceAmount={params.data.userCurrency.balance}
        unlockNeedsAmount={params.data.quantity}
        defaultEnableAutoDeduct={params.data.enableAutoDeduct}
        confirmButtonKey={params.buttons.confirm.text}
        cancelButtonKey={params.buttons.cancel.text}
        onClose={params.buttons.cancel.onPress}
        onConfirm={params.buttons.confirm.onPress}
        onEnableDeductChanged={params.buttons.onEnableDeductChanged}
      />
    ),
    backdropColor: '#1a1a1a',
    placement: 'bottom',
    noHeader: true,
    padding: '0px',
    height: '316px',
    onClose: params.buttons.cancel.onPress.bind(null, { type: 'CANCEL' })
  });

  modal.show();

  return modal;
};

export const createPaymentJolicoinModal = (params: {
  data: {
    userCurrency: IJoliCoin | IGem;
    paymentChoices: IPaymentChoice[];
    enableAutoDeduct: boolean;
    quantity: number;
    currency: 'JOLI_COIN' | 'JOLI_GEM';
  };
  buttons: {
    confirm: IButton;
    cancel: IButton;
    onEnableDeductChanged: (enalbed: boolean) => void;
  };
  onSelect: (productId: string) => void;
}) => {
  const modal = createModal({
    title: '',
    content: (
      <CoinPaymentContent
        currency={params.data.currency}
        balanceAmount={params.data.userCurrency.balance}
        unlockNeedsAmount={params.data.quantity}
        defaultEnableAutoDeduct={params.data.enableAutoDeduct}
        paymentChoices={params.data.paymentChoices}
        confirmButtonKey={params.buttons.confirm.text}
        cancelButtonKey={params.buttons.cancel.text}
        onClose={params.buttons.cancel.onPress}
        onConfirm={params.buttons.confirm.onPress}
        onEnableDeductChanged={params.buttons.onEnableDeductChanged}
        onSelect={params.onSelect}
      />
    ),
    backdropColor: '#1a1a1a',
    placement: 'bottom',
    noHeader: true,
    padding: '0px',
    height: '520px',
    onClose: params.buttons.cancel.onPress.bind(null, { type: 'CANCEL' })
  });

  modal.show();

  return modal;
};

export const createUnloginJolicoinModal = (params: {
  data: {
    rewardType: 'JOLI_COIN' | 'ADS-JOLI_COIN' | 'JOLI_GEM' | 'ADS-JOLI_GEM';
    rewardValue: number;
    currency: 'JOLI_COIN' | 'JOLI_GEM';
  };
  buttons: {
    confirm: IButton;
    cancel: IButton;
  };
}) => {
  const modal = createModal({
    title: '',
    content: (
      <CoinUnloginContent
        currency={params.data.currency}
        rewardType={params.data.rewardType}
        rewardValue={params.data.rewardValue}
        confirmButtonKey={params.buttons.confirm.text}
        cancelButtonKey={params.buttons.cancel.text}
        onClose={params.buttons.cancel.onPress}
        onConfirm={params.buttons.confirm.onPress}
      />
    ),
    backdropColor: '#1a1a1a',
    placement: 'center',
    noHeader: true,
    padding: '0px',
    preventCloseOnBackdropClick: true
  });

  modal.show();

  return modal;
};
